import { render, staticRenderFns } from "./installationAssetstant.vue?vue&type=template&id=07f9c364&scoped=true"
import script from "./installationAssetstant.vue?vue&type=script&lang=js"
export * from "./installationAssetstant.vue?vue&type=script&lang=js"
import style0 from "./installationAssetstant.vue?vue&type=style&index=0&id=07f9c364&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f9c364",
  null
  
)

export default component.exports